module.exports = __webpack_public_path__ + "media/images/badges/rowhouse/1mill-active-6d39c3c954e2e9fd73624bae36b320ab.png";